import PaymentMethod from '@alltrails/analytics/enums/PaymentMethod';
import WebProPurchaseLocation from '@alltrails/analytics/enums/WebProPurchaseLocation';
import logPurchaseSuccess from '@alltrails/analytics/events/logPurchaseSuccess';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import Coupon from 'types/Coupon';
import CurrencyCode from 'types/CurrencyCode';
import Plan from 'types/Plan';
import { track } from 'utils/OptimizelyHelpers';
import { LanguageSupportUtil } from 'utils/language_support_util';
import { getPurchaseScreenTypePlan } from './amplitudeHelper';
import { getPriceTotal, isTrial } from './PlanUtils';

// eslint-disable-next-line import/prefer-default-export
export function handlePaymentFormSuccess(
  currencyCode: CurrencyCode,
  coupon: Coupon,
  plan: Plan,
  languageRegionCode: LanguageRegionCode,
  couponCode: string,
  webProPurchaseLocation: WebProPurchaseLocation,
  paymentMethod: PaymentMethod
) {
  const { recurlyPlanCode, priceTotal } = plan;

  if (coupon) {
    track('Promo Conversion Annual');
  }

  const value = getPriceTotal(plan, coupon);

  // gtag events (not defined in local development)
  if (typeof gtag !== 'undefined') {
    // Currently, the only purchase option for GA UA config
    gtag('event', 'page_view', { page_path: '/pro/year/success' });
    // GA4
    // https://developers.google.com/analytics/devguides/collection/ga4/reference/events#purchase
    gtag('event', 'purchase', {
      currency: currencyCode,
      value,
      items: [
        {
          item_id: recurlyPlanCode,
          coupon: couponCode,
          discount: Number(plan.priceTotal) - value,
          item_category: 'Pro Subscription',
          currency: currencyCode,
          price: priceTotal
        }
      ]
    });
  }

  // FB Pixel
  // https://developers.facebook.com/docs/meta-pixel/reference#:~:text=PAGE_VIEW-,Purchase,-When%20a%20purchase
  // Check for presence of fbq in case of content blockers
  if (typeof fbq !== 'undefined') {
    fbq('track', 'Purchase', {
      currency: currencyCode,
      value,
      content_type: 'product',
      content_ids: [recurlyPlanCode]
    });
  }

  // TODO: Add Awin - https://alltrails.atlassian.net/browse/GROWTH-1211

  logPurchaseSuccess({
    campaign_id: couponCode,
    payment_method: paymentMethod,
    pro_upsell_experiment_variant_name: null, // only required on mobile
    product_id: recurlyPlanCode,
    purchase_screen_type_plan: getPurchaseScreenTypePlan(plan, coupon),
    purchase_screen_type: null, // only required on mobile
    transaction_date: null, // only required on mobile
    transaction_id: null, // only required on mobile
    web_purchase_location: webProPurchaseLocation
  });

  track('Pro Conversion');

  if (isTrial(plan)) {
    track('Start Trial');
  }

  if (recurlyPlanCode === 'alltrails_pro_annual_30' || recurlyPlanCode === 'alltrails_pro_annual_36') {
    track('Pro Conversion Annual');
  }

  const params = new URLSearchParams(window.location.search);

  if (params.has('returnTo')) {
    window.location.assign(params.get('returnTo')); // this is already wrapped
  } else {
    window.location.href = LanguageSupportUtil.wrapUrlSafe('/pro/welcome', languageRegionCode);
  }
}
